import Vue from 'vue'
import moment from 'moment-timezone'

Vue.filter('datetime', function (value, timeFormat) {
  if (!value) return ''
  return moment(value).format(timeFormat)
})
